import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SUNRISE_FOUNDATIONS_EXPERIENCE = defineFcm('sunrise_foundations_experience')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			// TODO: Include all pages or groups that should use the Sunrise Foundations experience
			keys: ['supporterFlow', 'starterFlow'] as const,
			optionalValues: true,
			shape: {
				type: 'object',
				optional: true,
				shape: {
					enabled: { type: 'boolean' },
					experimentName: { type: 'string' },
				},
			},
		}),
	)
	.withDefault({})
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'This FCM is used to enable the Sunrise Foundations experience',
		description: `This FCM is shared across multiple pages to ensure consistency during the progressive rollout of the Sunrise Foundations experience.
	The goal is to use a single experiment to guide users through the same experience across pages.
	However, it's flexible, you can assign different experiments per page if needed.
	To stop using this FCM, simply disable the experiment using the [enabled: false] flag.

	Groups for the experiment setup:

	C1 (Q2) — Supporter flow:
		- Petition Page (+ PSF)
		- PSF
		- *(TBD scope dependent) Header/Footer
		Experiment Mods to Get By No-Go Performance (~3-4 weeks)

	C2 — Starter flow
		- SAP (incl Login)
		- *(TBD scope dependent) Header/Footer
		Experiment Mods to Get By No-Go Performance (~2-3 weeks)

	Example usage:

	{
		supporterFlow: { enabled: true, experimentName: 'sunrise_full' },
  		starterFlow: { enabled: true, experimentName: 'sunrise_experiment_1' },
	}`,
		import: false,
		deprecated: 'Sunrise Foundations experience productized; front-end usage removed; safe to delete after 2026-08-03',
		template: {
			supporterFlow: {
				enabled: false,
				experimentName: '',
			},
			starterFlow: {
				enabled: false,
				experimentName: '',
			},
		},
	});
